import script from "./GestioneAppuntamentiCorsi.vue?vue&type=script&setup=true&lang=js"
export * from "./GestioneAppuntamentiCorsi.vue?vue&type=script&setup=true&lang=js"

import "./GestioneAppuntamentiCorsi.vue?vue&type=style&index=0&id=7930607a&scoped=true&lang=css"

import exportComponent from "/var/www/html/levante_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7930607a"]])

export default __exports__